module.exports = __webpack_public_path__ + "static/media/user.5da766b4.png";